module.exports = __webpack_public_path__ + "static/media/production-pressurize-01.f0dfdbb0.jpg";